import {RequestQueryBuilder, SCondition} from '@nestjsx/crud-request';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {TorchAPIConfiguration} from '../../../config/api.configuration';
import {HttpClient} from '@angular/common/http';
import {Burly} from 'kb-burly';
import {ManyResponse} from '../../../responses/many.response';
import {EODocument} from '../models/eo-document.model';

@Injectable({
  providedIn: 'root'
})
export class TorchEODocumentsService {

  constructor(protected config: TorchAPIConfiguration, private httpClient: HttpClient) {
  }


  public listDocuments(pageSize: number = 15,
                       currentPage: number = 0,
                       sortDirection: 'ASC' | 'DESC' | '' = 'DESC',
                       sortBy: string = 'optixID',
                       filters: SCondition | null): Observable<ManyResponse<EODocument>> {
    const qb = RequestQueryBuilder.create();

    qb.setPage(currentPage + 1).setLimit(pageSize);

    if (!!sortDirection) {
      qb.sortBy({field: sortBy, order: sortDirection});
    }

    if (!!filters) {
      qb.search(filters);
    }


    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/eo/documents')
      .appendRawQueryString(qb.query(false))
      .get;


    return this.httpClient.get<ManyResponse<EODocument>>(endpoint);
  }

  public searchRevisionCodes(revisionCode: string): Observable<string[]> {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/eo/documents/revisionCodes')
      .addQuery('revisionCode', revisionCode)
      .get;

    return this.httpClient.get<string[]>(endpoint);
  }
}
